import { render, staticRenderFns } from "./CategoriasCreate.vue?vue&type=template&id=07100500&"
import script from "./CategoriasCreate.vue?vue&type=script&lang=js&"
export * from "./CategoriasCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports